<template>
    <div>

        <b-row>
            <b-col cols="auto" class="mr-auto">
                <b-form-group>
                
                </b-form-group>
            </b-col>
            <b-col cols="auto" class="">
                <b-form-group>
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Data de Evento</span></b-button>
                </b-form-group>
            </b-col>
        </b-row>
        
        <b-row>
       
        <b-col cols="auto">
            <b-form-group>
                <label for="company" style="font-size: 0.8em">Ano</label>
                <b-form-select id="company"
                    v-model="filters.year"
                    :plain="true"
                    :options="yearDDL"
                    @change="refreshData"
                    :value="[null,'c']">
                </b-form-select>
            </b-form-group>
        </b-col>

        <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
        </b-col>

        <b-col cols="auto">
            <b-form-group>
                <label for="company" style="font-size: 0.8em">Status</label>
                <b-form-select id="company"
                    v-model="filters.statusId"
                    :plain="true"
                    :options="selectEventDateStatusDDL"
                    @change="refreshData"
                    :value="[null,'c']">
                </b-form-select>
            </b-form-group>
        </b-col>

        <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
            <p></p>
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
        </b-col>

        <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="table.perPage" id="perPage"
                :plain="true"
                :options="[5,10,20,50]">
                </b-form-select>
            </b-form-group>
        </b-col>
        
        </b-row>
        
  
        <b-table
            :items="filteredItems"
            :fields="table.fields"
            :select-mode="table.selectMode"
            responsive="sm"
            ref="selectableTable"
            selectable
            :primary-key="table.primaryKey"
            :tbody-transition-props="table.transProps"
            sort-icon-left
            @row-clicked="rowClicked"
            :per-page="table.perPage"
            :current-page="table.currentPage"
            :busy="table.isBusy"
            hover
            striped
            style="min-height: 300px"
            >

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>

            
            <template #cell(show_details)="row">
                <b-row>
                    <b-col cols="auto" class="mr-auto">
                        <b-form-group>
                        <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            
            <template #row-details="row">
                <b-card>
                    <b-row v-show="row.item.notes && row.item.notes.length > 0">
                        <b-col class="small">Notas:</b-col>
                    </b-row>
                    <b-row>
                        <b-col>{{ row.item.notes }}</b-col>
                    </b-row>
                    
                </b-card>
            </template>
            
            <template v-slot:cell(startDate)="data">
                {{ $utils.localDateShortTime(data.item.startDate) }}<br>
                <!-- - {{ $utils.localDateShortTime(data.item.endDate) }} -->
                <span class="text-primary">{{ data.item.subject }}</span>
                
            </template>

            <template v-slot:cell(st)="data">
                <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
            </template>
            
            <template v-slot:cell(ispublic)="data">
                <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
            </template>

            <template v-slot:cell(action)="data">
                <b-button size="sm" variant="danger" @click="openDeleteModal(data.item)" class="mr-1 btn-brand" title="Excluir" style="margin-bottom: 4px">
                <i class="fa fa-close"></i></b-button>
                
                <b-button size="sm" variant="primary" @click="openPresenceModal(data.item)" class="mr-1 btn-brand" title="Lista de Presença" style="margin-bottom: 4px">                        
                <i class="fa fa-address-book-o"></i></b-button>
        
            </template>
            
        </b-table>
        <nav>
            <b-pagination :total-rows="totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Anterior" next-text="Próximo" />
        </nav>
  
        <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Data de Evento"
            size="lg"
            >
            <event-date-component :item="currentItem" :companyId="companyId" @resp="handleResp"></event-date-component>
            
        </b-modal>

        <b-modal
              v-model="presenceModal"
              id="presence-modal"
              centered
              hide-footer
              title="Lista de Presença"
              size="lg"
              >
              <event-participant-date-grid-component :item="currentItem" :eventDateId="currentItem.id"></event-participant-date-grid-component>
        </b-modal>

        <b-modal title="Excluir" class="modal-delete" v-model="deleteModal" @ok="deleteItem" cancel-title="Cancelar" >
            Deseja realmente excluir o evento?
        </b-modal>

    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";
import { Switch as cSwitch } from '@coreui/vue'
import EventParticipantDateGridComponent from './EventParticipantDateGridComponent'
import EventDateComponent from './EventDateComponent'

/* DataTimePicker */
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}
  
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'eventDateGridComponent',
    props: {
       companyId: 0,       
       item: {}
    },
    components: {
      cSwitch,
      EventParticipantDateGridComponent,
      EventDateComponent,
      datePicker
    },
    data: () => {
        return {   
            deleteModal: false,
            deleteSelectItem: null,
            datePickerOptions: {
                format: 'DD/MM/YYYY HH:mm',
                useCurrent: false,
            },
           newItem: {},
           yearDDL: [
            { value: 2024, text: '2024' }
           ],
           currentItem: {},
           editModal: false,
           presenceModal: false,
           eventDateStatusDDL: [],
           items: [],
           filters: {
            statusId: 1,
            key: '',
            status: 1,
            year: 2024
           },      
           switchLabelIcon: {
                dataOn: '\u2713',
                dataOff: '\u2715'
            },
           table: {
            fields: [
                {key: 'show_details', label: "", thStyle: { width: "40px" } },
                //{key: 'id' },
                //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
                {key: 'startDate', label: 'Data do Evento', sortable: true  },
                //{key: 'serviceDescription', label: 'Descrição do Serviço', sortable: true },
                {key: 'participants', label: 'Participantes', sortable: true, class: 'text-center', thStyle: { width: "50px" }},
                {key: 'presences', label: 'Presenças', sortable: true, class: 'text-center', thStyle: { width: "50px" }},
                {key: 'abscences', label: 'Faltas', sortable: true, class: 'text-center', thStyle: { width: "50px" }},
                {key: 'justifiedAbscences', label: 'Justificadas', sortable: true, class: 'text-center', thStyle: { width: "50px" }},
                //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
                //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
                //{key: 'description', label: 'Descrição', sortable: false },
                //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
                {key: 'status.name', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "200px" } },
                //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
                { key: 'action', label: 'Ações', sortable: false, thStyle: { width: "90px" } , class: 'text-center'}
                
            ],
            sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
            currentPage: 1,
            perPage: 50,
            isBusy: false,
            modes: ['multi', 'single', 'range'],
            selectMode: 'multi',
            primaryKey: "id",
            transProps: {
               name: 'flip-list'
            }
           }
        }
    },
    computed: {
        selectedItem() {
            return this.item
        },
        selectEventDateStatusDDL: function() {
            var list = [...this.eventDateStatusDDL]
            list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
            list.unshift({ value: '0' , text: '- Todos -' })
            return list
        },
        totalRows: function () { return this.getRowCount() },
        filteredItems() {
            try {
                return this.items.filter(item => {
                return (this.filters.key == '' || (
                    this.$utils.filterString(item.name, this.filters.key)
                    //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    ))
                    && (this.filters.statusId==0 || item.statusId == this.filters.statusId )                  
                })
            }
            catch(e) {
                return this.items;
            }
        }
    },
    methods: {
        handleResp(obj) {
            this.editModal = false
            this.refreshData()
        },
        openDeleteModal(i) {
            this.deleteSelectItem = i
            this.deleteModal = true
            
        },
        async deleteItem() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.delete(
                this.$store.state.ws_url + "/event?id=" + this.deleteSelectItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.deleteModal = false
            }
            ).catch(function (error) {
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Evento',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 3000
                })                
            });

        },
        getRowCount: function () {
            if(this.items)
                return this.items.length
            else
                return 0;
        },

        async getEventDateStatus() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/event/date/status/ddl?companyId=" + this.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.eventDateStatusDDL = resp.data.obj;
          }
          ).catch(function (error) {
            toast ({
                    type: VueNotifications.types.error,
                    title: 'Evento',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })       
          });

          this.isBusy = false;
    
        },

        rowClicked(i) {
            this.openEditModal(i)
        },
        
        openPresenceModal(i) {
            if(i == null) {
                this.currentItem = { ...this.newItem };
            }
            else {
                this.currentItem = { ...i };
            }
            this.presenceModal = true;
        },

        openEditModal(i) {
            if(i == null) {
                this.currentItem = { ...this.newItem }

                this.currentItem.eventId = this.selectedItem.id
                this.currentItem.statusId = 1
                if(this.selectedItem.weekDaysList && this.selectedItem.weekDaysList.length > 0) {
                    var weekday = this.selectedItem.weekDaysList[0]
                    this.currentItem.startDate = this.$utils.dateChangeTime(this.$utils.nextDayOfWeek(new Date(),weekday),8,0)
                    this.currentItem.endDate = this.$utils.dateChangeTime(this.$utils.nextDayOfWeek(new Date(),weekday),10,0)
                }
                else {
                    this.currentItem.startDate = this.$utils.dateChangeTime(new Date(),8,0)
                    this.currentItem.endDate = this.$utils.dateChangeTime(new Date(),10,0)
                }
                
            }
            else {
                this.currentItem = { ...i };
                this.currentItem.startDate = new Date(this.currentItem.startDate)
                this.currentItem.endDate = new Date(this.currentItem.endDate)
            }
            this.editModal = true;
        },

        async refreshData() {
       
            var s = this;
            var currentUser = this.$store.state.currentUser;
            this.isBusy = true;

            if(s.companyId && s.selectedItem && s.selectedItem.id) {

                var url = ''
                url = this.$store.state.ws_url + "/event/date?companyId=" + s.companyId + "&eventId=" + s.selectedItem.id + "&year=" + s.filters.year + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

                await axios.get(
                    url
                ).then(function (resp) {
                    s.items = resp.data.obj;
                }).catch(function (error) {
                    toast ({
                        type: VueNotifications.types.error,
                        title: 'Evento',
                        message: 'Sem permissão de acesso. Verifique e tente novamente.',
                        timeout: 3000
                    })
                });
            }

            this.isBusy = false;
        
        }
    },
    mounted: function() {
        this.refreshData()
        this.getEventDateStatus()
    }
}
</script>